export default {
  applicationlog: [],
  errorlog:[]
};
